import { OFFICE_VISUAL_MODERN } from './officeVisual';

// Production never enables demonstration authentication or the QA profile endpoint.
export function isLocalQaPreview({ hostname = typeof window === 'undefined' ? '' : window.location.hostname, enabled = process.env.REACT_APP_LOCAL_QA_PREVIEW } = {}) {
  return enabled === 'true' && ['localhost', '127.0.0.1', '[::1]'].includes(hostname);
}

export function authVisualPreview(user, options = {}) {
  const visual = options.visual ?? (typeof document === 'undefined' ? undefined : document.documentElement.dataset.authPreview);
  if (isLocalQaPreview(options) && visual === 'classic') return undefined;
  return OFFICE_VISUAL_MODERN;
}

export const AUTH_VISUAL_MEMORY_KEY = 'aurax:personal-auth-visual';
// Kept for existing callers. General presentation no longer depends on browser storage.
export function rememberAuthVisualPreview() {}
